"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slatePlugins = require("@udecode/slate-plugins");
var _element = _interopRequireDefault(require("./element"));
var _deserialize = _interopRequireDefault(require("./deserialize"));
var _render = _interopRequireDefault(require("./render"));
var LinkPlugin = function LinkPlugin(options) {
  var _setDefaults = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    link = _setDefaults.link;
  return {
    renderElement: (0, _render["default"])(options),
    deserialize: (0, _deserialize["default"])(options),
    inlineTypes: [link.type]
  };
};
var _default = exports["default"] = LinkPlugin;